import { TradingDetailsServicePlanFormNew_MX } from './mixed';

export const TradingDetailsServicePlanFormNew = {
  SPB: TradingDetailsServicePlanFormNew_MX,
  /**
   * - Financial Product
   */
  FP: TradingDetailsServicePlanFormNew_MX,
};
